module.exports = __webpack_public_path__ + "img/luckyDraw-bg.ec8ead8d.png";